import React from 'react';
import { PageHeader } from '../PageHeader';
import { ActivityFeed } from '../ActivityFeed';
import { RightRail } from '../RightRail';
export function FeedPage() {
  return <>
      <PageHeader title="Feed" subtitle="The latest from across the company." data-id="element-478" data-mp="1dnqyjmk67wto" />
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_340px] gap-6" data-id="element-479" data-mp="1dlmxdcdnpbx3">
        <div className="min-w-0 max-w-2xl w-full" data-id="element-480" data-mp="18pfnj8i53g9v">
          <ActivityFeed data-id="element-481" data-mp="kz23a45sqlpu" />
        </div>
        <div className="hidden xl:block" data-id="element-482" data-mp="l04t08rdui46">
          <RightRail data-id="element-483" data-mp="gxqe1zqu42i6" />
        </div>
      </div>
    </>;
}